import { Reducer } from "redux";

import { PostIngestProcessResponse } from "../models/api/Referral";
import { IngestProcessDispatchTypes } from "../models/dispatchTypes/Referral";
import { IngestProcessActionDispatchTypes } from "../constants/Referral";

const initialState: PostIngestProcessResponse = {
  loading: false,
  response: "",
  error: null,
};

const PostIngestProcessReducer: Reducer<
PostIngestProcessResponse,
IngestProcessDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case IngestProcessActionDispatchTypes.INGEST_PROCESS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case IngestProcessActionDispatchTypes.INGEST_PROCESS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case IngestProcessActionDispatchTypes.INGEST_PROCESS_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case IngestProcessActionDispatchTypes.INGEST_PROCESS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostIngestProcessReducer;
